export const MENU_OPTIONS = [
    { title: 'Edit', value: 'edit' },
    { title: 'Delete', value: 'delete' }
];
